import {
  SET_PS_CREDITS,
  SET_PS_TOTALFP,
  SET_PS_TOTALFP_L4,
  SET_PS_SELL_BY,
  SET_PS_PPG_YEAR,
  SET_PS_PPG_L4,
  SET_PS_GPP,
  SET_PS_H2H,
  SET_PS_PROJ_VAL,
  SET_PS_VAL_YEAR,
  SET_PS_VAL_L4,
  SET_PS_CEIL,
  SET_PS_FLOOR,
  SET_PS_CAP,
  SET_PS_VCAP,
  SET_PS_PROJ_FP,
  SET_PS_CAP_COUNT,
  SET_PS_VCAP_COUNT,
  SET_PS_DT_COUNT,
  SET_PS_M_COUNT,
  SET_PS_DTA,
  SET_PS_TFPR,
  SET_PS_TFPR_L4,
  SET_PS_AFPR,
  SET_PS_AFPR_L4,
  SET_PS_TFP,
  SET_PS_TFP_L4,
  SET_PS_AFP,
  SET_PS_AFP_L4 
} from "./PlayerStatInformation";

const initial_information = {
  ps_ceil: true,
  ps_floor: true,
  ps_credits: true,
  ps_gpp: true,
  ps_h2h: true,
  ps_ppgL4: true,
  ps_ppgYear: true,
  ps_projVal: true,
  ps_sellBy: true,
  ps_totalFP: true,
  ps_totalFPL4: true,
  ps_valL4: true,
  ps_valYear: true,
  ps_vcap: false,
  ps_cap: false,
  ps_proj_fp: true,
  ps_dta: true,
  ps_tfpr_count: false,
  ps_tfprL4_count: false,
  ps_afpr_count: false,
  ps_afprL4_count: false,
  ps_tfp: false,
  ps_tfpL4: false,
  ps_afp: false,
  ps_afpL4: false,
};
const keyMap = {
  ps_ceil: SET_PS_CEIL,
  ps_floor: SET_PS_FLOOR,
  ps_credits: SET_PS_CREDITS,
  ps_gpp: SET_PS_GPP,
  ps_h2h: SET_PS_H2H,
  ps_ppgL4: SET_PS_PPG_L4,
  ps_ppgYear: SET_PS_PPG_YEAR,
  ps_projVal: SET_PS_PROJ_VAL,
  ps_sellBy: SET_PS_SELL_BY,
  ps_totalFP: SET_PS_TOTALFP,
  ps_totalFPL4: SET_PS_TOTALFP_L4,
  ps_valL4: SET_PS_VAL_L4,
  ps_valYear: SET_PS_VAL_YEAR,
  ps_proj_fp: SET_PS_PROJ_FP,
  ps_cap_count: SET_PS_CAP_COUNT,
  ps_dt_count: SET_PS_DT_COUNT,
  ps_vcap_count: SET_PS_VCAP_COUNT,
  ps_m_played: SET_PS_M_COUNT,
  ps_dta: SET_PS_DTA,
  ps_tfpr_count: SET_PS_TFPR,
  ps_tfprL4_count: SET_PS_TFPR_L4,
  ps_afpr_count: SET_PS_AFPR,
  ps_afprL4_count: SET_PS_AFPR_L4,
  ps_tfp: SET_PS_TFP,
  ps_tfpL4: SET_PS_TFP_L4,
  ps_afp: SET_PS_AFP,
  ps_afpL4: SET_PS_AFP_L4 
};

export const setPlayerStat = (key, value) => {
  var obj = {};
  obj["type"] = keyMap[key];
  obj[key] = value;
  console.log("PlayerAction: ", obj, key);
  return obj;
};
